'use strict';
import { UserType } from './user-type.enum';
var UserBuilder = /** @class */ (function () {
    function UserBuilder(user) {
        var defaultUser = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            email: 'bobobob@gmail.com',
            signature: '',
            receiveNotifications: true,
            isAgent: false,
            firstName: 'Bob',
            lastName: 'Johnson',
            fullName: 'Bob Johnson',
            creationDate: Date.now() - 3600,
            lastUpdateDate: Date.now(),
            website: '',
            userType: UserType.AUTHENTICATED,
            profileImage: 'https://d2eyqiy4n03ve6.cloudfront.net/12345678-1234-1234-1234-1234567890ab.png',
            phoneNumbers: [],
            banned: false
        };
        this.user = user || defaultUser;
    }
    UserBuilder.prototype.withUserId = function (userId) {
        this.user.id = userId;
        return this;
    };
    UserBuilder.prototype.withUserEmail = function (userEmail) {
        this.user.email = userEmail;
        return this;
    };
    UserBuilder.prototype.withSignature = function (signature) {
        this.user.signature = signature;
        return this;
    };
    UserBuilder.prototype.withIsAgent = function (isAgent) {
        this.user.isAgent = isAgent;
        return this;
    };
    UserBuilder.prototype.withProfileImage = function (imgSrc) {
        this.user.profileImage = imgSrc;
        return this;
    };
    UserBuilder.prototype.withWebsiteUrl = function (url) {
        this.user.website = url;
        return this;
    };
    UserBuilder.prototype.withReceiveNotifications = function (newStatus) {
        this.user.receiveNotifications = newStatus;
        return this;
    };
    UserBuilder.prototype.withCreationDate = function (date) {
        this.user.creationDate = date;
        return this;
    };
    UserBuilder.prototype.withLastUpdateDate = function (date) {
        this.user.lastUpdateDate = date;
        return this;
    };
    UserBuilder.prototype.withPermissionLevel = function (permissionLevel) {
        this.user.permissionLevel = permissionLevel || undefined;
        return this;
    };
    UserBuilder.prototype.withUserType = function (userType) {
        this.user.userType = userType;
        return this;
    };
    UserBuilder.prototype.withFirstName = function (name) {
        this.user.firstName = name;
        if (!this.user.fullName) {
            this.user.fullName = name;
        }
        return this;
    };
    UserBuilder.prototype.withLastName = function (name) {
        this.user.lastName = name;
        return this;
    };
    UserBuilder.prototype.withFullName = function (name) {
        this.user.fullName = name;
        return this;
    };
    UserBuilder.prototype.withPhoneNumbers = function (phoneNumbers) {
        this.user.phoneNumbers = phoneNumbers;
        return this;
    };
    UserBuilder.prototype.withCompanyId = function (companyId) {
        this.user.companyId = companyId;
        return this;
    };
    UserBuilder.prototype.withCompanyIds = function (companyIds) {
        this.user.companyIds = companyIds;
        return this;
    };
    UserBuilder.prototype.withCompany = function (company) {
        this.user.company = company;
        return this;
    };
    UserBuilder.prototype.withNumberOfTickets = function (tickets) {
        this.user.numberOfTickets = tickets;
        return this;
    };
    UserBuilder.prototype.withRoleId = function (roleId) {
        this.user.roleId = roleId;
        return this;
    };
    UserBuilder.prototype.withCompaniesPermissions = function (companiesPermissions) {
        this.user.companiesPermissions = companiesPermissions;
        return this;
    };
    UserBuilder.prototype.withTwitterHandle = function (twitterHandle) {
        this.user.twitterHandle = twitterHandle;
        return this;
    };
    UserBuilder.prototype.withInstagramHandle = function (instagramHandle) {
        this.user.instagramHandle = instagramHandle;
        return this;
    };
    UserBuilder.prototype.build = function () {
        return this.user;
    };
    return UserBuilder;
}());
export { UserBuilder };
//# sourceMappingURL=user-builder.js.map